export const siteName = '中文字幕 日韩';

export const siteDescription = '专注中文字幕 日韩影视内容，涵盖日韩剧、日韩电影、综艺全系列中文字幕资源推荐与使用指南，帮助中文用户轻松看懂日韩原版内容，字幕清晰准确，更新及时，是日韩影视爱好者的首选导航平台。';

export const siteKeywords = '中文字幕 日韩,日韩剧中文字幕,日韩电影中文字幕,日韩综艺中文字幕,日韩番剧中文字幕,日韩最新剧集字幕,日韩影视字幕下载';

export const siteUrl = 'https://hnshancai.cn';

export const contactInfo = {
  email: 'contact@zhongwenzimu-rihan.com',
  wechat: 'ZimuRiHan',
  qq: '1234567890',
  address: '中国上海市浦东新区张江高科技园区',
};

export const brandInfo = {
  name: '中文字幕 日韩',
  slogan: '让每一部日韩好片，都有中文相伴',
  founded: '2018',
  mission: '我们致力于为中文观众打造最全面、最及时的日韩影视中文字幕资源平台。从热门日剧韩剧到经典电影，从人气综艺到小众番剧，我们用心筛选、整理每一份字幕资源，确保字幕翻译准确、时间轴精准、更新及时。',
  story: '2018年，一群热爱日韩影视的字幕爱好者发现，中文观众在寻找日韩影视中文字幕时面临资源分散、质量参差不齐的问题。于是我们创建了"中文字幕 日韩"平台，旨在整合优质字幕资源，让每一位日韩影视爱好者都能轻松找到满意的中文字幕。经过多年发展，我们已经成长为日韩影视字幕领域最受信赖的资源导航平台之一。',
};